import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const packingPackageLasmile = createAction(ACTION.PACKING_PACKAGE_LASTMILE.REQUEST);

export const packingPackageLasmileDetail = createAction(ACTION.PACKING_PACKAGE_LASTMILE_DETAIL.REQUEST);
